import { indexHome, indexWithDetail } from "@/server/api";
import { ajax } from "@/assets/js/ajax.js";
import unit from "@/assets/js/common";

/*
  有些模块下 因为没有统计数量的接口 前端手动需要合计多个接口的count
*/
function union(arr) {
  if (!arr || !arr.length) return [];

  const tmp = {};
  arr.forEach((obj) => {
    if (obj.type in tmp) {
      tmp[obj.type].count += obj.count;
    } else {
      tmp[obj.type] = { ...obj };
    }
  });

  return Object.values(tmp);
}

const state = {
  Data: {},
  Top: [],
  message: [],
};

const mutations = {
  SETH(state, value) {
    state.Data = value;
  },
  SetTop(state, value) {
    state.Top = value;
  },
  setMess(state, value) {
    state.message = value;
  },
};

/**
 * 根据权限过滤数据
 */
function PowerNums(json) {
  const data = { ...json };
  const hasAuth = unit.AUTH;

  return {
    ...data,
    auditCount: data.auditCount,
    stepRemindCount: data.stepRemindCount,
    // newItemCount: data.newItemCount,
    newItemCount: hasAuth("welcome:new:communicate:cause")
      ? data.newItemCount
      : hasAuth("welcome:email")
      ? data.newItemCount
      : 0,
    loanCount: hasAuth("welcome:loan") ? data.loanCount : 0,
    keepCount: hasAuth("welcome:keep") ? data.keepCount : 0,
    causeAgingCount: hasAuth("welcome:causeAging:index")
      ? data.causeAgingCount
      : 0,
    carryCount: hasAuth("welcome:carry:index") ? data.execAgingCount : 0,
    shipReceiveRemindCount: hasAuth("welcome:emailmsg")
      ? data.shipReceiveRemindCount
      : 0,
    auctionCount: hasAuth("welcome:sell") ? data.auctionRemind : 0,
  };
}

// 首页的二级分类的初始值定义
const initialization = {
  optionList: [],
  shipRemind: {
    accept: 0,
    register: 0,
    supp: 0,
    total: 0,
  },
  talkData: {
    talkAfterJudCount: 0,
    talkCount: 0,
    talkExecCount: 0,
    total: 0,
  },
  futureCount: 0,
  overdueCount: 0,
  expireCount: 0,
  expiredCount: 0,
  adventRemindCount: 0,
  expireRemindCount: 0,
  normalRemindCount: 0,
  remindCount: 0,
  remindDelayCount: 0,
  aMonthsCount: 0,
  oneYearsCount: 0,
  threeMonthsCount: 0,
  twentyMonthsCount: 0,
  twoYearsAgoCount: 0,
  twoYearsCount: 0,
  validityRemindCount: 0,
  validityRemindDelayCount: 0,
  remindDelayCount: 0,
  remindingCount: 0,
  auctionCount: 0,
  auctionWillCount: 0,
};

/**
 * 根据类型和权限过滤数据
 */
function permission(type, data) {
  const hasAuth = unit.AUTH;
  const result = { ...data };

  const typeHandlers = {
    1: () => {
      result.shipRemind = {
        accept: hasAuth("welcome:email") ? data.shipRemind.accept : 0,
        register: hasAuth("welcome:email") ? data.shipRemind.register : 0,
        supp: hasAuth("welcome:email") ? data.shipRemind.supp : 0,
        total: data.shipRemind.total,
      };
      result.talkData = {
        talkAfterJudCount: hasAuth("welcome:new:communicate:beforExec")
          ? data.talkData.talkAfterJudCount
          : 0,
        talkCount: hasAuth("welcome:new:communicate:cause")
          ? data.talkData.talkCount
          : 0,
        talkExecCount: hasAuth("welcome:new:communicate:InExec")
          ? data.talkData.talkExecCount
          : 0,
        total: data.talkData.total,
      };
    },
    3: () => {
      result.futureCount = hasAuth("welcome:loan") ? data.futureCount : 0;
      result.overdueCount = hasAuth("welcome:loan") ? data.overdueCount : 0;
    },
    4: () => {
      result.expireCount = hasAuth("welcome:keep") ? data.expireCount : 0;
      result.expiredCount = hasAuth("welcome:keep") ? data.expiredCount : 0;
    },
    5: () => {
      const auth = hasAuth("welcome:causeAging:index");
      result.adventRemindCount = auth ? data.adventRemindCount : 0;
      result.expireRemindCount = auth ? data.expireRemindCount : 0;
      result.normalRemindCount = auth ? data.normalRemindCount : 0;
      result.remindCount = auth ? data.remindCount : 0;
      result.remindDelayCount = auth ? data.remindDelayCount : 0;
    },
    6: () => {
      const auth = hasAuth("welcome:carry:index");
      result.aMonthsCount = auth ? data.aMonthsCount : 0;
      result.oneYearsCount = auth ? data.oneYearsCount : 0;
      result.threeMonthsCount = auth ? data.threeMonthsCount : 0;
      result.twentyMonthsCount = auth ? data.twentyMonthsCount : 0;
      result.twoYearsAgoCount = auth ? data.twoYearsAgoCount : 0;
      result.twoYearsCount = auth ? data.twoYearsCount : 0;
      result.validityRemindCount = auth ? data.validityRemindCount : 0;
      result.validityRemindDelayCount = auth
        ? data.validityRemindDelayCount
        : 0;
    },
    8: () => {
      const auth = hasAuth("welcome:emailmsg");
      result.remindDelayCount = auth ? data.remindDelayCount : 0;
      result.remindingCount = auth ? data.remindingCount : 0;
    },
    9: () => {
      const auth = hasAuth("welcome:sell");
      result.auctionCount = auth ? data.auctionCount : 0;
      result.auctionWillCount = auth ? data.auctionWillCount : 0;
    },
  };

  if (typeHandlers[type]) {
    typeHandlers[type]();
  }

  return result;
}

const actions = {
  async seth({ commit }) {
    try {
      const e = await indexWithDetail();
      const data = PowerNums(e);

      const rdata = {
        auditCount: data.auditCount,
        stepRemindCount: data.stepRemindCount,
        newItemCount: data.newItemCount,
        loanCount: data.loanCount,
        keepCount: data.keepCount,
        causeAgingCount: data.causeAgingCount,
        carryCount: data.carryCount,
        emailCount: data.shipReceiveRemindCount,
        auctionCount: data.auctionCount,
        shipRemindCount: data.shipRemindCount,
      };

      commit("setMess", e.msgList);
      commit("SETH", rdata);
      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async getKey({ commit }, data) {
    commit("SetTop", initialization); //默认值

    const getCodeList = async (v) => {
      //公共 调用
      if (v.url === "audit/lists") return null;

      try {
        const response = await ajax({
          url: v.url,
          data: { type: v.type },
          type: "get",
        });
        return permission(v.type, response);
      } catch (error) {
        console.error(`Failed to fetch ${v.url}:`, error);
        return null;
      }
    };

    try {
      const results = await Promise.all(data.map(getCodeList)); //循环抛请求
      const validResults = results.filter(Boolean); //初始状态进行请求
      if (validResults.length) {
        commit("SetTop", validResults[0]);
      }
    } catch (error) {
      // console.error("Failed to get key data:", error);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
